import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  filters: {
    searchText: '',
    category: null,
    date: null,
    status: null,
  },
  isDataFetching: false,
  isServerErrorOnList: false,
  isServerDataNotFoundErrorOnList: false,
  isServerErrorOnDynamicForm: false,
  reportsData: {
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalRecords: 0,
    },
    data: [],
    selectedReports: [],
  },
  generateReport: {
    reportCategory: null,
    reportName: null,
    reportCategoryDropdownOptions: [],
    reportNameDropdownOptions: [],
    dynamicFieldsData: {
      mandatoryFields: [],
      optionalFields: [],
    },
    blobData: {
      allBlobData: [],
      selectedBlobData: {},
      allEmployerData: [],
      selectedEmployerData: {},
      allLocationData: [],
      selectedLocationData: {},
    },
  },
};

export const reportsSlice = createSlice({
  name: 'reportsAdmin',
  initialState: INITIAL_STATE,
  reducers: {
    setReportsFilter: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetReportsFilter: (state, action) => {
      state.filters = INITIAL_STATE.filters;
      state.reportsData.selectedReports = [];
      state.reportsData.pagination = INITIAL_STATE?.reportsData?.pagination;
    },
    setSelectedReports: (state, action) => {
      state.reportsData.selectedReports = action.payload;
    },
    resetSelectedReports: (state, action) => {
      state.reportsData.selectedReports = [];
    },
    setReportsDataFetching: (state, action) => {
      state.isDataFetching = action.payload;
    },
    setIsServerErrorOnList: (state, action) => {
      state.isServerErrorOnList = action.payload;
    },
    setIsServerErrorOnDynamicForm: (state, action) => {
      state.isServerErrorOnDynamicForm = action.payload;
    },
    setIsServerDataNotFoundErrorOnList: (state, action) => {
      state.isServerDataNotFoundErrorOnList = action.payload;
    },
    setReportsData: (state, action) => {
      state.reportsData.data = action.payload;
    },
    setReportsPagination: (state, action) => {
      state.reportsData.pagination = {
        ...state.reportsData.pagination,
        ...action.payload,
      };
    },
    setReportCategory: (state, action) => {
      state.generateReport.reportCategory = action.payload;
      state.generateReport.reportName = null;
    },
    setReportName: (state, action) => {
      state.generateReport.reportName = action.payload;
    },
    setReportCategoryDropdownOptions: (state, action) => {
      state.generateReport.reportCategoryDropdownOptions = action.payload;
    },
    setReportNameDropdownOptions: (state, action) => {
      state.generateReport.reportNameDropdownOptions = action.payload;
    },
    setDynamicFields: (state, action) => {
      state.generateReport.dynamicFieldsData = action.payload;
    },
    resetGenerateReport: (state, action) => {
      state.generateReport.reportCategory = null;
      state.generateReport.reportName = null;
      state.isServerErrorOnDynamicForm = false;
      state.generateReport.reportNameDropdownOptions = [];
      state.generateReport.dynamicFieldsData = {
        mandatoryFields: [],
        optionalFields: [],
      };
      state.blobData = {
        allBlobData: [],
        selectedBlobData: {},
        allEmployerData: [],
        selectedEmployerData: {},
        allLocationData: [],
        selectedLocationData: {},
      };
    },
    setBlobData: (state, action) => {
      state.blobData = { ...state.blobData, ...action.payload };
    },
    resetBlobData: (state, action) => {
      state.blobData = {
        allBlobData: [],
        selectedBlobData: {},
        allEmployerData: [],
        selectedEmployerData: {},
        allLocationData: [],
        selectedLocationData: {},
      };
    },
    resetReportsSlice: (state, action) => {
      state.filters = INITIAL_STATE.filters;
      state.reportsData.selectedReports = [];
      state.reportsData.pagination = INITIAL_STATE?.reportsData?.pagination;
      state.reportsData.selectedReports = [];
      state.isDataFetching = false;
      state.isServerErrorOnList = false;
      state.isServerDataNotFoundErrorOnList = false;
      state.isServerErrorOnDynamicForm = false;
      state.reportsData.data = [];
      state.reportsData.pagination = {
        pageNumber: 1,
        pageSize: 10,
        totalRecords: 0,
      };
      state.generateReport.reportCategory = null;
      state.generateReport.reportName = null;
      state.generateReport.reportNameDropdownOptions = [];
      state.generateReport.reportCategoryDropdownOptions = [];
      state.generateReport.dynamicFieldsData = {
        mandatoryFields: [],
        optionalFields: [],
      };
      state.blobData = {
        allBlobData: [],
        selectedBlobData: {},
        allEmployerData: [],
        selectedEmployerData: {},
        allLocationData: [],
        selectedLocationData: {},
      };
    },
  },
});

export const {
  setReportsFilter,
  resetReportsFilter,
  setReportsDataFetching,
  setReportsData,
  setSelectedReports,
  resetSelectedReports,
  setReportsPagination,
  setIsServerErrorOnList,
  setIsServerDataNotFoundErrorOnList,
  setReportCategory,
  setReportName,
  setReportCategoryDropdownOptions,
  setReportNameDropdownOptions,
  setDynamicFields,
  resetGenerateReport,
  resetReportsSlice,
  setBlobData,
  resetBlobData,
  setIsServerErrorOnDynamicForm,
} = reportsSlice.actions;

export default reportsSlice.reducer;
